export default function Buttons({view, save, cancel}){
    return (
        <div className="formDiv">
            {!view &&
                <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
            {!view &&
                <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>}
        </div>
    )
}